/*
 * Folders (versioned collections of documents) for TPRM third parties and UCRM businesses.
 */
import { FileUpdates, UploadedFile } from './Files';
import { DueDiligenceModule } from './ProductModule';

export interface FolderTypes {
    type_set: string[];
}

export interface CreateOrUpdateFolderRequest {
    name: string;
    type: string;
    organization_manager_notifications_enabled: boolean;
    effective_date?: string;
    expiration_date?: string;
    comments?: string;
    file_updates?: FileUpdates;
}

/**
 * A version of a TPRM or UCRM folder.
 * @param third_party_id The ID of the organization (TPRM third party or UCRM business) that the folder belongs to. The TPRM-specific name is fixed by existing TPRM data, unless we decide to do a migration.
 * @param vendor_manager_notifications_enabled Corresponds to `CreateOrUpdateFolderRequest.organization_manager_notifications_enabled`. The TPRM-specific name is fixed by existing TPRM data, unless we decide to do a migration.
 */
export interface FolderVersion {
    created_time: string;
    id: string;
    last_updated: string;
    last_updated_by: string;
    name: string;
    third_party_id: string;
    type: string;
    vendor_manager_notifications_enabled: boolean;

    effective_date?: string;
    expiration_date?: string;
    comments?: string;
    files?: UploadedFile[];
}

export interface FolderAllVersions {
    current_version: FolderVersion;
    past_versions: FolderVersion[];
}

/**
 * Identifies the page a user navigated from when clicking a folder name or "Create Folder" in `FoldersTable`.
 * Used to render an origin-aware breadcrumb on the folder pages, so the user can navigate back to where they came from.
 */
export enum FolderBreadcrumbSource {
    FOLDERS_LISTING = 'foldersListing',
    ASSESSMENT_SUBJECT_DASHBOARD = 'assessmentSubjectDashboard',
}

export type ManageFolderOrigin =
    | {
          source: FolderBreadcrumbSource.FOLDERS_LISTING;
          module: DueDiligenceModule;
      }
    | {
          source: FolderBreadcrumbSource.ASSESSMENT_SUBJECT_DASHBOARD;
          module: DueDiligenceModule;
          assessmentSubjectDisplayName: string;
          assessmentSubjectId: string;
          organizationId: string;
      };

export enum FoldersSortFilterOptions {
    NAME = 'name',
    TYPE = 'type',
    DOCUMENTS = 'documents',
    EFFECTIVE_DATE = 'effective_date',
    EXPIRATION_DATE = 'expiration_date',
    LAST_UPDATED_BY = 'last_updated_by',
    LAST_UPDATED = 'last_updated',
}
